import React from 'react';
import { IndicatorDetails } from '../../../../ReportBuilder/Components/IndicatorDetails/utils';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import TrueImpactLevelFeedbackModal from 'shared/design-system/components/TrueImpactLevelFeedbackModal';

interface ForecastMatchWarningModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (note: string) => void;
  initialNote: string;
  forecastMatches: IndicatorDetails[];
  finalForecastMatches: IndicatorDetails[];
  sourceSectionLabel: string;
  targetSectionLabel: string;
  isInterimStage: boolean;
}

const ForecastMatchWarningModal: React.FC<ForecastMatchWarningModalProps> = ({
  open,
  onClose,
  onConfirm,
  initialNote,
  forecastMatches,
  finalForecastMatches,
  sourceSectionLabel,
  targetSectionLabel,
  isInterimStage,
}) => {
  const matchCount = forecastMatches.length + finalForecastMatches.length;

  return (
    <TrueImpactLevelFeedbackModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      confirmText="Save"
      initialNote={initialNote}
      placeholder={`Please explain why the ${sourceSectionLabel} forecast matches a ${targetSectionLabel} forecast.`}
      message={
        <>
          The value you entered for this <strong>{sourceSectionLabel}</strong>{' '}
          indicator matches the following <strong>{targetSectionLabel}</strong>{' '}
          {matchCount === 1 ? 'indicator' : 'indicators'}:
          <ul style={{ margin: `${SPACERS.tiny} 0` }}>
            {forecastMatches.map(t => (
              <li key={`f-${t.indicatorId}`}>
                <strong>{t.indicatorName}</strong> (Forecast)
              </li>
            ))}
            {finalForecastMatches.map(t => (
              <li key={`ff-${t.indicatorId}`}>
                <strong>{t.indicatorName}</strong> (
                {isInterimStage ? 'Updated Forecast' : 'Final Results'})
              </li>
            ))}
          </ul>
          Program Development is meant to capture how your program improved
          internally this year and not who you reached. Consider updating these
          indicators to reflect program-level improvements.
          <br />
          <br />
          These sections typically measure different things. Please provide a
          brief explanation before saving.
        </>
      }
    />
  );
};

export default ForecastMatchWarningModal;
